import React, { useState } from "react"
import styled from "styled-components"
import Layout from "../../components/layout"
import SEO from "../../components/seo"
import BildHeader from "../../images/services/augenvorsorge/header.jpg"
import BildLinks from "../../images/services/augenvorsorge/links.jpg"
import BildRechts from "../../images/services/augenvorsorge/rechts.jpg"
import SubNavigation from "../../components/SubNavServices"
import PlayIcon from "../../assets/play-icon.svg"
import Termin from "../../components/Termin"

const VideoLink = styled.a`
  display: block;
  position: relative;

  &:after {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-image: url(${PlayIcon});
    background-position: center;
    background-size: 60px;
    background-repeat: no-repeat;
    opacity: 0.5;
    transition: 0.05s background-size;
  }

  &:hover {
    &:after {
      opacity: 0.7;
      background-size: 67px;
    }
  }
`

const Augenvorsorge: React.FC = () => {
  const siteTitle = "Augenvorsorge – Dienstleistungen"
  const [isSubMenuOpen, setSubMenuOpen] = useState(false)

  return (
    <Layout title={siteTitle}>
      <SEO title={siteTitle} />
      <section className="wrapper">
        <div className="headerImage">
          <img src={BildHeader} />
        </div>
      </section>
      <Termin />
      <SubNavigation
        isSubMenuOpen={isSubMenuOpen}
        setSubMenuOpen={setSubMenuOpen}
        activeMenuText="Augenvorsorge"
      />
      <section className="wrapper greyColor content">
        <h1>Augenvorsorge</h1>
        <h2 className="contentSubtitle">SCHWARZ Optik – Seit 1992 in Heiden</h2>
        <div className="contentColumns">
          <div className="contentColumn">
            <div className="imageCollection">
              <div className="imageColumn">
                <div className="imageRow">
                  <img src={BildLinks} />
                </div>
              </div>
              <div className="imageColumn">
                <div className="imageRow">
                    <img src={BildRechts} />
                </div>
              </div>
            </div>
            <p className="imageCaption">
              <strong>Schielen bei Kindern</strong>
            </p>
            <h2>Vorbeugende Beurteilung der Sehfunktion</h2>
            <p>
              Ihre Sehleistung beeinflusst mehr als nur das Lesen: Konzentration, Reaktion, physische Leistung im Alltag und Beruf. Daher ist gutes Sehen Lebensqualität.<br />
              Durch präzise Messmethoden erkennen wir Sehstörungen frühzeitig und begleiten Sie gezielt – bevor es zu spürbaren Einschränkungen kommt.
            </p>
            <h2>Seh- und Augenpflege</h2>
            <p>
              Müde Augen, flimmernde Buchstaben, anstrengendes Lesen? Wahrscheinlich haben sie diese Erfahrungen schon gemacht: Sie sitzen stundelang vor dem Fernseher oder lesen ein Buch und plötzlich wird’s mühsam. Solche Beschwerden entstehen oft durch feine, unerkannte Sehfehler.
            </p>
            <p>
              SCHWARZ Optik erkennt mithilfe optometrischer Messverfahren schon früh Auffälligkeiten auch bei Kindern. Bei Kindern werden diese kleinen Sehfehler oft zu spät bemerkt. Mit modernen Spezialmessungen wie die Prüfung des Sehgleichgewichts oder des beidäugigen Sehens spüren wir Unregelmässigkeiten auf und korrigieren sie gezielt. 
            </p>
            <p>
              So wird Ihre Sehhilfe zur echten Entlastung individuell angepasst an Ihre Sehaufgaben im Alltag.
            </p>
          </div>
          <div className="contentColumn">
            <h2>Augenvorsorge – sehen, bevor etwas passiert.</h2>
            <p>
              Seit über 30 Jahren kümmern wir uns in Heiden um das Wichtigste: Ihre Augen.<br />
              Ob Kinder, Berufstätige oder Senioren unsere präventiven Augenanalysen und optometrischen Untersuchungen decken frühzeitig Sehstörungen auf und sorgen dafür, dass Sie klarer, gesünder und entspannter sehen können.
            </p>
            <h2>Sonnen- & Augenschutz</h2>
            <p>
              Ob beim Autofahren, Wandern oder Skifahren – unsere Augen sind täglich stark gefordert.<br />Individueller Sonnenschutz für Ihre Augen schützt vor UV-Strahlen, Blendung und Überanstrengung.<br />
              Wir beraten Sie persönlich und finden die passende Lösung für jede Lebenssituation.
            </p>
          </div>
        </div>
      </section>
    </Layout>
  )
}

export default Augenvorsorge
